import { format as dateFnsFormat } from "date-fns";
import deLocale from "date-fns/locale/de";
import { DashboardFilterState } from "src/types";
import * as _ from "lodash";

export function format(date: Date | number, formatString: string) {
  return dateFnsFormat(date, formatString, { locale: deLocale });
}

export const numberFormat = (value: number, withDecimal?: boolean) => {
  let formatter;
  if (withDecimal === true) {
    formatter = new Intl.NumberFormat(navigator.language, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(Number(value));
    return formatter;
  } else {
    formatter = new Intl.NumberFormat(navigator.language, {
      maximumFractionDigits: 2,
    }).format(value);
    return formatter;
  }
};

export function isFeatureEnabled(flag: string | undefined): boolean {
  return (
    flag === "true" ||
    flag === "y" ||
    flag === "1" ||
    flag === "" ||
    flag === undefined
  );
}

export function roundNumber(number: number, decimals: number): number {
  return Math.round(number * 10 * decimals) / (10 * decimals);
}

export function dashboardFiltersPartiallyEqual(
  oldDashboardFilter: DashboardFilterState,
  newDashboardFilter: DashboardFilterState,
  omit: (keyof DashboardFilterState)[]
): boolean {
  return _.isEqual(
    _.omit(oldDashboardFilter, omit),
    _.omit(newDashboardFilter, omit)
  );
}



// WEBPACK FOOTER //
// ./src/utilities/index.tsx